
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_650_34051)","fill":"current"}},[_c('path',{attrs:{"d":"M4.48 4.129h2.11V.889c-.881.289-1.673 1.525-2.11 3.24zM4.48 9.871c.437 1.715 1.229 2.951 2.11 3.24v-3.24H4.48zM13.59 4.95H.41a.41.41 0 00-.41.41v3.28c0 .227.184.41.41.41h13.18a.41.41 0 00.41-.41V5.36a.41.41 0 00-.41-.41zm-.48 1.413l-.821 1.64a.41.41 0 01-.734 0l-.453-.906-.454.907c-.14.278-.594.278-.734 0l-.786-1.572a.398.398 0 01-.082-.21.405.405 0 01-.038.141l-.82 1.64a.41.41 0 01-.735 0L7 7.098l-.453.907c-.14.278-.595.278-.734 0l-.82-1.64a.404.404 0 01-.037-.136.42.42 0 01-.098.23l-.772 1.546a.41.41 0 01-.734 0l-.454-.907-.453.907a.41.41 0 01-.734 0l-.82-1.64a.41.41 0 11.734-.368l.453.907.454-.907c.145-.291.582-.303.733 0l.454.907.453-.907a.426.426 0 01.394-.226.42.42 0 01.389.397.406.406 0 01.771-.17l.454.906.453-.907c.14-.278.595-.278.734 0l.453.907.454-.907a.405.405 0 01.77.167.394.394 0 01.366-.391c.169-.004.344.077.418.224l.453.907.454-.907c.14-.278.594-.278.734 0l.453.907.453-.907a.41.41 0 01.734.367zM7.41 9.871v3.24c.881-.289 1.673-1.525 2.11-3.24H7.41zM7.41.889v3.24h2.11C9.083 2.414 8.291 1.178 7.41.889z"}}),_c('path',{attrs:{"d":"M3.637 9.871H.671C1.792 12.333 4.275 14 7 14c-1.482 0-2.776-1.632-3.363-4.129zM10.363 9.871C9.776 12.368 8.482 14 7 14c2.725 0 5.208-1.667 6.329-4.129h-2.966zM.671 4.129h2.966C4.224 1.632 5.518 0 7 0 4.275 0 1.792 1.667.671 4.129zM7 0c1.482 0 2.776 1.632 3.363 4.129h2.966C12.208 1.667 9.725 0 7 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_650_34051"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    